import React, { useState, useEffect } from "react";
import axios from "axios";
import { useParams } from 'react-router-dom';
import moment from "moment";


interface IShipmentContext {
    shipment: IShipment
    isLoading: boolean

    getShipment: () => Promise<void>
}

export let shipmentContext = React.createContext<IShipmentContext>({} as IShipmentContext);

let { Provider } = shipmentContext;

interface IShipment {
    id: string
    shipmentId: string
    shipmentDate: moment.Moment
    trackingNumber: string
    trackingUrl: string
    carrierCode: string
    shipmentLines: IShipmentLine[]
    glsContractNumber: string
    glsBranchCode: string
    canAddTrackingNumber: boolean
    deliveryStatus: string
    glsStatus: string
}

interface IShipmentLine {
    sku: string
    quantity: string
    orderId: string
    orderNumber: string
    eRPOrderNumber: string
    eRPOrderLineId: string
    isInvoiced: boolean
}

export let ShipmentProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
    let { id } = useParams<{ id: string }>();

    let [shipment, setShipment] = useState<IShipment>({} as IShipment);
    let [isLoading, setLoading] = useState(true);

    useEffect(() => {
        getShipment();
    }, [id])

    let getShipment = async () => {
        try {
            let res = await axios.get('/api/Shipment/GetShipment', { params: { shipmentId: id } });

            let { item } = res.data;
            setShipment(item);

        } catch (err) { }
        finally {
            setLoading(false);
        }
    }


    return (
        <Provider value={{
            shipment,
            isLoading,

            getShipment
        }}>
            {children}
        </Provider>
    );
};